import { Component, Input, OnInit } from '@angular/core';
import { TabsModuleService } from '@fi-app/utilities/tabs/tabs-module.service';
import { StatisticService } from '@fi-shared/statistic/statistic.service';
import { ModuleType } from '@fi-shared/types';

@Component({
    selector: 'fi-customer-billing-price-list-state',
    template: ` <fi-customer-billing-price-list> </fi-customer-billing-price-list> `,
    standalone: false,
})
export class CustomerBillingPriceListStateComponent implements OnInit {
    constructor(
        private tabsModuleService: TabsModuleService,
        private statisticService: StatisticService,
    ) {}

    ngOnInit(): void {
        this.statisticService.Visit(ModuleType.Billing);
    }
}
